/* import __COLOCATED_TEMPLATE__ from './main-content-loading.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();